import * as paths from "./paths";

export const authRoutes: ModuleRoute[] = [paths.login, paths.register];

export const homeRoutes: ModuleRoute[] = [paths.home];

export const btRoutes: ModuleRoute[] = [paths.backtest];

const routes: ModuleRoute[] = [...authRoutes, ...homeRoutes, ...btRoutes];

export default routes;

export { paths };
